module.exports = __webpack_public_path__ + "static/media/sunset_7.73bf2ff6.webp";